import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import permission from './directive/permission';

import ElementPlus from "element-plus"
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import "./assets/styles/common.scss"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.use(store).use(router).use(ElementPlus,{locale:zhCn}).directive('permission', permission).mount('#app')
// import "@/lib/rem"

router.beforeEach( (to, from, next) => {
  if(!to.meta.auth){
    return next()
  }
  if(store.state.app.token){
    return next()
  }
  return next('/login')
})


